import { ErrorBoundary } from "@sentry/react";

import { Attribution, Typography } from "~/common/components";
import { SubmittedConsultationReportDataRenderer } from "~/providers/components";
import { ConsultationExportDownloadLink } from "~/providers/components/pdf/ConsultationExport/ConsultationExportDownloadLink";
import { PatientConsultationReport } from "~/providers/utils/types/consultation";

interface SubmittedConsultationReportProps {
  data: PatientConsultationReport;
}

export const SubmittedConsultationReport = ({
  data,
}: SubmittedConsultationReportProps) => {
  const { completed_at: completedAt, completed_by } = data;
  const completedBy = completed_by?.team_member;

  return (
    <div className="flex flex-col gap-4 pb-6">
      <div className="flex w-full justify-between">
        <Typography className="text-sm text-gray-35">
          <Attribution
            firstName={completedBy?.name}
            lastName={completedBy?.last_name}
            date={completedAt}
          />
        </Typography>
        <div className="-my-2.5">
          <ErrorBoundary>
            <ConsultationExportDownloadLink />
          </ErrorBoundary>
        </div>
      </div>
      <div
        id="printable-content"
        className="print-container flex flex-col gap-3"
      >
        <SubmittedConsultationReportDataRenderer data={data} />
      </div>
    </div>
  );
};
